import { gql } from '@nerdwallet/apollo';

export const projectTedQuery = gql`
  mutation ProjectTedFormResponse($form: JSON) {
    addProjectTedForm(form: $form) {
      formStatus
    }
  }
`;
